import { PendingReviewScreen } from "@/features/vendor/pre-vetting";

export default PendingReviewScreen;
